var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('OzContainedButton',{attrs:{"color-scheme":_vm.OzContainedButtonColorScheme.AlternativeHeavy,"text":_vm.text,"center-text":true},on:{"click":function($event){return _vm.$emit('click')}},scopedSlots:_vm._u([{key:"leftIcon",fn:function(){return [_c('OzIcon',{attrs:{"name":_vm.icon}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }